/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assigned/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Date from './Date/index'
import Person from './Person/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Assigned({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/EffectiveDate/Status/InfoTooltip/Content/Assigned"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Assigned.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 text="Assigned by"
/>
<Person
  viewPath={`${viewPath}/Person`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 text="on"
/>
<Date
  viewPath={`${viewPath}/Date`}
/>
</div>
{children}
</React.Fragment>)
}